export default "__VITE_ASSET__Sk6IHKmG__"